import { render } from "./christophSpace.vue?vue&type=template&id=3e5e471c"
import script from "./christophSpace.vue?vue&type=script&lang=js"
export * from "./christophSpace.vue?vue&type=script&lang=js"

import "./christophSpace.vue?vue&type=style&index=0&id=3e5e471c&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__